/*
 * @Author: bbqin
 * @Date: 2022-08-24 16:49:17
 * @LastEditTime: 2022-09-05 15:54:08
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\adapters\page.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as log from '../utils/log';
import { getCacheExtendJson, analysisPageEventExtend } from '../model/free';
import { compatibleCheckedMethod } from '../model/single';

export { preventEvent, preventDefault } from '../model/free';

/**
 * 获取解析后的方法
 * @param {*} scope 
 * @param {*} name 
 * @param {*} defaultf 
 * @returns 
 */
const handlePageEventExtend = function (scope, name, defaultf) {
    let freeExtendCacheJson = getCacheExtendJson();

    // 兼容旧版本
    if (!freeExtendCacheJson) {
        let res = compatibleCheckedMethod(scope, name, defaultf);
        return res;
    }

    return function (...params) {
        return analysisPageEventExtend(freeExtendCacheJson, name, scope, defaultf, ...params);
    };
};

/**
 * 定时器，检测是否完成，然后执行
 * @param {*} callback 
 * @param {*} condition 
 * @param {*} time 
 * @param {*} maxCount 
 */
export const runInterval = (callback, condition, time = 100, maxCount = 10) => {
    // 检测后执行
    var count = 0;
    var pid = setInterval(() => {
        let res = condition && condition();
        count++;
        if (res || count === maxCount) {
            clearInterval(pid);
            log.blue(`runInterval callback use ${count} 次，耗时 ${count * time}`);
            callback && callback();
        }
    }, time);
};

/**
 * 获取校验后的扩展方法
 * @param {*} obj 
 * @param {*} name 
 * @param {*} defaultf 
 * @returns 
 */
export const getCheckedExtendMethod = function (obj, name, defaultf) {
    let freeExtendCacheJson = getCacheExtendJson();
    if (!freeExtendCacheJson) {
        let res = compatibleCheckedMethod(obj, name, defaultf);
        return res;
    }
    return handlePageEventExtend(obj, name, defaultf);
};

